# Phase 1: Developer Dashboard

Familiarise yourself with the [Developer Dashboard],
an administrative user interface that lets you observe and configure your SEEK API integration.

It’s now a key component of our [integration process] and can be used to:

- Interact with [Job Posting] feature references
- Manage your [webhook subscriptions]
- Configure notification channels for release notes and system health
- Create and rotate your [client credentials]
- Run [Playground] operations in the GraphQL Explorer

If you haven’t been onboarded to the Developer Dashboard,
submit a request to our [Integration Service Desk] to gain access.

[client credentials]: /auth#client-credentials
[Developer Dashboard]: /manage
[integration process]: /introduction#integration-process
[job posting]: /use-cases/job-posting
[playground]: /graphql/playground
[webhook subscriptions]: /events/webhooks
[Integration Service Desk]: https://forms.office.com/r/SCZdDyx0BJ
